import React, { useContext, useEffect } from "react";
import { Card, Spinner } from "react-bootstrap";
import FileContext from "../../../context/files/FileContext";

const FileCards = () => {
  const fileContext = useContext(FileContext);
  const { uploadedFiles, getFilesLoading } = fileContext;

  const handleDeleteClick = (file) => {
    fileContext.deleteFile(file.Key)
      .catch((err) => {
        console.log(err);
      })
  }

  useEffect(() => {
    fileContext.getFiles('kon');
  }, []);

  return (
    <div style={{
      borderBottom: "2px solid #e8e8e8",
      paddingBottom: 16
    }}>
      {getFilesLoading &&
        <div style={{ width: 'fit-content', margin: '24px auto 24px auto' }}>
          <Spinner animation="border" role="status" />
        </div>
      }

      {!getFilesLoading && uploadedFiles.length === 0 &&
        <div style={{ textAlign: 'center', padding: 16 }}>
          No Files Found
        </div>
      }

      <div style={{ maxHeight: 450, overflowY: 'scroll' }}>
        {!getFilesLoading && uploadedFiles.map((element) => (
          <Card key={element.id} className="m-2 d-flex " border="gray">
            <Card.Body>

              <Card.Text className="d-flex justify-content-between">
                <div>
                  {/* Filename */}
                  <span style={{ fontSize: 14, fontWeight: 500 }}>
                    {element.Key.split('.')[2] + '.' + element.Key.split('.')[3]}
                  </span>
                  <br />

                  {/* Date */}
                  <span
                    style={{ fontSize: 12 }}
                    className='text-muted'>
                    {new Date(element.LastModified).toLocaleString()}
                  </span>
                  <br />
                  {/* Description */}
                  <span style={{ fontSize: 12 }}>
                    {element.Key.split('.')[1] || ''}
                  </span>
                </div>

                <button
                  onClick={() => handleDeleteClick(element)}
                  className="btn btn-sm btn-primary" type="submit"
                  style={{ height: 25, width: 25, fontSize: 11 }}>
                  X
                </button>
              </Card.Text>
            </Card.Body>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default FileCards;
